import React, { useCallback } from "react";
import Button from "../components/modernized/Button";
import themePropTypes from "../theme/theme-prop-types";
import { isFieldsValid } from "../utils/field-validation";
import calculatePadding from "../utils/padding-utils";

const ModernizedButton = ({
  field,
  appData: { handleButtonClick },
  appData,
  screen
}) => {
  const { name, label, size, variant, action, block, __noValidation } = field;
  const { screenRef } = appData;
  const theAction = action ?? screen.action;
  const handleClick = useCallback(event => {
    if (field.action) {
      const skipValidation = !theAction?.needsValidation || __noValidation;
      if (skipValidation || isFieldsValid(appData)) {
        event.stopPropagation();
        handleButtonClick(field.name, field.text, field.action);
      } else if (screenRef?.current?.scrollIntoView) {
        screenRef.current.focus();
        screenRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    }
  });

  const padding = calculatePadding(field);

  return (
    <div style={padding} className='ModernizedButton-button-wrapper-web-sdk'>
      <Button
        type='button'
        name={name}
        variant={variant}
        size={size}
        block={block}
        onClick={handleClick}
      >
        {label}
      </Button>
    </div>
  );
};

ModernizedButton.propTypes = themePropTypes.modernizedButton;

export default ModernizedButton;
